import * as React from 'react'
import classNames from 'classnames'

import './styles.css'

export default function FormError(props) {
  return <span className={classNames('FormError', props.className)}>{props.msg}</span>
}
